module.exports = __webpack_public_path__ + "static/signature-e316167f850f59e78fd721599535f5d1.png";